import { IncidentModel } from './incident.model';

export class IncidentLawEnforcementModel extends IncidentModel {

    private _arrestDate: Date;

    public incidentLawEnforcementId = 0;
    public lawEnforcementAgencyId = 0;
    public citingAgencyTypeId = 0;
    public accidentTypeId = 0;
    public incidentAdminPerSeTestTypeId = 0;
    public tempPermitGenderTypeId = 0;
    public tempPermitEyeColorTypeId = 0;
    public tempPermitHairColorTypeId = 0;
    public tempPermitDriverLicenseClassTypeId = 0;
    public complaintNumber = '';
    public charge1 = '';
    public charge2 = '';
    public charge3 = '';
    public charge4 = '';
    public charge5 = '';
    public charge6 = '';
    public otherCharge = '';
    public otherChargeDisplay = '';
    public hazardousMaterialIndicator = false;
    public commercialMotorVehicleIndicator = false;
    public passengerIndicator = false;
    public operatingHireFlag = false;
    public cdlHolderIndicator = false;
    public get arrestDate(): Date {
        return this._arrestDate;
    }
    public set arrestDate(value: Date) {
        this._arrestDate = this.ensureDate(value);
    }
    public arrestTime = '';
    public arrestLocation = '';
    public probableCauseIndicator = '2';
    public stopReason = '';
    public officerInitials = '';
    public reasonableGroundsIndicator = '2';
    public stopReasonFacts = '';
    public testStatusBAC = '';
    public testResultsBAC1: any;
    public testResultsBAC2: any;
    public testStatusDrugs = '';
    public testResultsDrugs = '';
    public personRefusedNotes = '';
    public hearingLocation = '';
    public officerName = '';
    public officerBadge = '';
    public officerSignature = '';
    public officerStation = '';
    public testOperatorName = '';
    public testOperatorNumber = '';
    public officerBadge2 = '';
    public officerName2 = '';
    public officerBadge3 = '';
    public officerName3 = '';
    public officerBadge4 = '';
    public officerName4 = '';
    public surrenderLicenseIndicator = '';
    public surrenderLicenseOther = '';
    public suspensionServedIndicator = false;
    public suspensionServedDate = '';
    public suspensionServedTime = '';
    public tempPermitWeight = '';
    public tempPermitHeight = '';
    public tempPermitEndorsements = '';
    public tempPermitRestrictions = '';
    public tempPermitPermitNotIssuedReason = '';
    public personUnderArrestFlag = '';
    public admonitionsReadFlag = '';
    public admonitions1 = '';
    public consentToTest = '';
    public consentToTest_Y = '';
    public arresteesComments1 = '';
    public admonitions2 = '';
    public consentToTest_N = '';
    public arresteesComments2 = '';
    public admonitions3 = '';
    public consentToTest_N_Delayed = '';
    public arresteesComments3 = '';
    public arrestComments = '';
    public testCompleteFlag = '';
    public testDelayedFlag = '';
    public dlPresentedFlag = '';
    public InterpreterId = '';
    public InterpreterLanguage = '';
    public InterpreterName = '';
    public InterpreterUsedFlag = '';
    public processedDate = '';
    public driverLicenseJurisdictionId: number;
    public driverLicenseNumber: string;
    public probableCauseFacts = '';
    public reasonableGroundsFacts = '';
    public bloodTestResults = '';
    public bloodTestResultsBAC = '';
}
